"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11 1a1 1 0 010 2v3l3 7v1.25a.75.75 0 01-.75.75H2.75a.75.75 0 01-.75-.75V13l3-7V3a1 1 0 110-2h6zM9 3H7v3l-1.714 4h5.428L9 6V3z"];
//# sourceMappingURL=lab-test.js.map